<div class="container-fluid mt-4">
  <div class="row">
    <!-- Columna de la lista de trabajos -->
    <div class="col-lg-4 col-md-12 mb-3">
     <div class="d-flex justify-content-between align-items-center mb-2">
        <h4>Servicios activos</h4>
        <button class="btn btn-primary btn-sm" (click)="openNewWorkModal()">
            <i class="bi bi-plus-circle-fill me-1"></i> Crear nuevo servicio
        </button>
      </div>
      <div class="mb-3">
        <input type="text" class="form-control form-control-sm" placeholder="Buscar por cliente, N° caso, bicicleta..." [formControl]="workSearchControl" />
      </div>
      <div class="list-group workshop-list">
        <ng-container *ngIf="filteredWorkshopWorks$ | async as works; else loadingWorksTemplate">
          <div *ngIf="works.length > 0; else noWorksFoundBasedOnFilterTemplate">
            <a *ngFor="let item of works"
             href="javascript:void(0);"
             class="list-group-item list-group-item-action"
             [class.active]="selectedWork?.id === item.id"
             (click)="selectWork(item)">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{ item.caseNumber }} - {{ item.clientName }}</h5>
              <div>
                <span class="badge me-1" [ngClass]="getStatusClass(item.currentStatus)">{{ getSpanishStatus(item.currentStatus) }}</span>
                <span *ngIf="item.billingStatus === 'billed'" class="badge bg-success me-1" title="Facturado"><i class="bi bi-currency-dollar"></i></span>
                <span *ngIf="item.notifiedStatus === 'notified'" class="badge bg-primary" title="Cliente Notificado"><i class="bi bi-envelope-check-fill"></i></span>
                <span class="badge bg-dark rounded-pill">Turno {{ item.originalIndex + 1 }}</span>
              </div>
            </div>
            <p class="mb-1 text-truncate">{{ item.description }}</p>
            <small>Total: {{ item.totalPrice | currency:'DOP':'RD$' }}</small>
          </a>
          </div>
          <ng-template #noWorksFoundBasedOnFilterTemplate>
            <div class="list-group-item">
              <span *ngIf="workSearchControl.value; else noWorksAtAllTemplate">No se encontraron trabajos con el término de búsqueda.</span>
              <ng-template #noWorksAtAllTemplate>No hay trabajos activos. ¡Cree uno nuevo!</ng-template>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #loadingWorksTemplate>
          <div class="list-group-item">Cargando trabajos...</div>
        </ng-template>
      </div>
    </div>
    
    <!-- Columna de detalles del trabajo -->
    <div class="col-lg-8 col-md-12">
      <div *ngIf="selectedWorkId$ | async as workId; else noWorkSelected">
<ng-container *ngIf="{ work: (selectedWorkDetails$ | async), bike: (selectedBikeDetails$ | async) } as details; else loadingWorkDetails">
          <div *ngIf="details.work" class="card">
            <!-- Card Header -->
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="mb-0 text-truncate">Detalles para: {{ details.work.caseNumber }} - {{details.work.clientName}}</h4>
              <div class="d-flex align-items-center">
                  <div class="form-check form-switch me-3" *ngIf="details.work.currentStatus !== 'Completed'">
                      <input class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" id="billingStatusSwitch" [checked]="details.work.billingStatus === 'billed'" (change)="onBillingStatusChange($event, details.work!)" [disabled]="isUpdatingBillingStatus">
                      <label class="form-check-label" for="billingStatusSwitch">{{ details.work.billingStatus === 'billed' ? 'Facturado' : 'Pendiente facturar' }}</label>
                  </div>
                  <button class="btn btn-outline-primary btn-sm" (click)="printReceipt(details.work)" title="Imprimir Ticket de Recepción">
                      <i class="bi bi-printer-fill"></i>
                  </button>
              </div>
            </div>
            
            <!-- Card Body -->
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-6">
                  <p><strong>Cliente:</strong> {{ details.work.clientName }}</p>
                  <p><strong>Bicicleta:</strong> {{ details.bike?.brand }} {{ details.bike?.model || '' }}</p>
                  <p *ngIf="details.bike?.color"><strong>Color:</strong> {{ details.bike!.color }}</p>
                  <p *ngIf="details.bike?.chassis"><strong>Chasis:</strong> {{ details.bike!.chassis }}</p>
                   <p ><strong>Solicitud del cliente:</strong> {{ details.work!.description }}</p>
                   <p><strong>Tipo servicio:</strong> {{ details.work.serviceType }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Fecha de entrada:</strong> {{ details.work.entryDate?.toDate() | date:'medium':'':'es-DO' }}</p>
                  <p><strong>Total Actual:</strong> {{ details.work.totalPrice | currency:'DOP':'RD$' }}</p>
                </div>
              </div>
              <div class="p-3 mb-4 border rounded-3 bg-white shadow-xs d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="fw-bold text-dark mb-1"><i class="bi bi-shield-check text-primary me-2"></i>Inspección multipuntos</h6>
                  <p class="text-muted small mb-0">Registre niveles de fluidos, desgaste de llantas y mapee daños estructurales en el gráfico interactivo.</p>
                </div>
                <button class="btn btn-outline-primary btn-sm rounded-pill px-3 fw-semibold" [routerLink]="['/inspection', details.work.caseNumber]">
                  <i class="bi bi-arrow-right-circle me-1"></i>Abrir inspección
                </button>
              </div>

              <!-- Sección Agregar Artículos -->
              <div *ngIf="details.work.currentStatus !== 'Ready' && details.work.currentStatus !== 'Completed'">
                  <hr>
                  <h5>Agregar mano de obra, repuestos y artículos</h5>
                  <div class="row">
                    <!-- MANO DE OBRA -->
                    <div class="col-lg-6">
                        <h6>Mano de obra</h6>
                        <div class="mb-2">
                            <input type="text" class="form-control form-control-sm" placeholder="Buscar servicio..." [formControl]="laborSearchControl" />
                        </div>
                        <form [formGroup]="manLaborProductAddForm" (ngSubmit)="onAddItemToWork('Labor')">
                            <div class="row g-2 mb-2">
                                <div class="col-8">
                                  <select class="form-select form-select-sm" formControlName="selectedProduct">
                                      <option [ngValue]="null" disabled>Elegir servicio...</option>
                                      <option *ngFor="let product of manLaborProducts$ | async" [ngValue]="product">{{product.id}}-{{ product.nombre }} ({{ product.precio | currency:'DOP':'symbol':'1.2-2' }})</option>
                                  </select>
                                </div>
                                <div class="col-4">
                                  <input type="number" class="form-control form-control-sm" formControlName="quantity" min="1" placeholder="Cant.">
                                </div>
                            </div>
                            <!-- Asignación de Trabajadores -->
                            <div class="input-group input-group-sm mb-3">
                                <span class="input-group-text"><i class="bi bi-person"></i></span>
                                <!-- Dropdown General -->
                                <select class="form-select" formControlName="assignee1">
                                  <option [ngValue]="null">Personal (N/A)</option>
                                  <option *ngFor="let emp of allActiveEmployees$ | async" [value]="emp.id">{{ emp.type === 'Mecánico' ? 'Mec' : 'Asis' }}: {{ emp.name }}</option>
                                </select>
                                <!-- Segundo Dropdown EXCLUSIVO PARA FULL -->
                                <select *ngIf="isFullService(manLaborProductAddForm.get('selectedProduct')?.value)" class="form-select" formControlName="assignee2">
                                  <option [ngValue]="null">Segundo (N/A)</option>
                                  <option *ngFor="let emp of allActiveEmployees$ | async" [value]="emp.id">{{ emp.type === 'Mecánico' ? 'Mec' : 'Asis' }}: {{ emp.name }}</option>
                                </select>
                                <button type="submit" class="btn btn-success" [disabled]="manLaborProductAddForm.invalid || isAddingLaborItem"><i class="bi bi-plus"></i></button>
                            </div>
                        </form>
                    </div>

                    <!-- REPUESTOS -->
                    <div class="col-lg-6">
                        <h6>Repuestos/otros artículos</h6>
                        <div class="mb-2">
                            <input type="text" class="form-control form-control-sm" placeholder="Buscar repuesto..." [formControl]="partSearchControl" />
                        </div>
                        <form [formGroup]="partsProductAddForm" (ngSubmit)="onAddItemToWork('Part')">
                            <div class="row g-2 mb-2">
                              <div class="col-8">
                                <select class="form-select form-select-sm" formControlName="selectedProduct">
                                    <option [ngValue]="null" disabled>Elegir repuesto...</option>
                                    <option *ngFor="let product of partsProducts$ | async" [ngValue]="product">{{product.id}}-{{ product.nombre }} ({{ product.precio | currency:'DOP':'symbol':'1.2-2' }})</option>
                                </select>
                              </div>
                              <div class="col-4">
                                <input type="number" class="form-control form-control-sm" formControlName="quantity" min="1" placeholder="Cant.">
                              </div>
                            </div>
                            <div class="input-group input-group-sm mb-3">
                                <span class="input-group-text"><i class="bi bi-person"></i></span>
                                <select class="form-select" formControlName="assignee1">
                                  <option [ngValue]="null">Personal (N/A)</option>
                                  <option *ngFor="let emp of allActiveEmployees$ | async" [value]="emp.id">{{ emp.type === 'Mecánico' ? 'Mec' : 'Asis' }}: {{ emp.name }}</option>
                                </select>
                                <button type="submit" class="btn btn-info" [disabled]="partsProductAddForm.invalid || isAddingPartItem"><i class="bi bi-plus"></i></button>
                            </div>
                        </form>
                    </div>
                  </div>
                  <div *ngIf="addItemError" class="alert alert-danger mt-2 py-2">{{ addItemError }}</div>
              </div>

              <!-- Lista de Artículos Agregados -->
              <h5 class="mt-4">Artículos Agregados</h5>
              <ul *ngIf="details.work.addedItems?.length; else noItemsAdded" class="list-group">
                <li *ngFor="let item of details.work.addedItems" class="list-group-item d-flex justify-content-between align-items-center">
                  <div>
                    <div class="fw-bold">{{item.productId}}-{{ item.productName }} (x{{ item.quantity }})
                      <span class="badge ms-2" [ngClass]="{'bg-primary': item.itemType === 'Labor', 'bg-secondary': item.itemType === 'Part'}">{{ item.itemType === "Labor" ? "Servicio" : "Artículo" }}</span>
                    </div>
                    <!-- AUTORES DEL TRABAJO -->
                    <small class="text-muted d-block mt-1" *ngIf="item.mechanicName || item.assistantName">
                      <i class="bi bi-person-fill"></i> 
                      {{ item.mechanicName ? 'Mec: ' + item.mechanicName : '' }}
                      {{ item.mechanicName && item.assistantName ? ' | ' : '' }}
                      {{ item.assistantName ? 'Asis: ' + item.assistantName : '' }}
                    </small>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="me-3">{{ item.unitPrice * item.quantity | currency:"DOP":"RD$" }}</span>
                    <button *ngIf="details.work.currentStatus !== 'Ready' && details.work.currentStatus !== 'Completed'" class="btn btn-outline-danger btn-sm" (click)="confirmRemoveItem(item)" [disabled]="isRemovingItem" title="Eliminar artículo"><i class="bi bi-trash"></i></button>
                  </div>
                </li>
              </ul>
              <ng-template #noItemsAdded><p>Aún no se han agregado artículos.</p></ng-template>

              <!-- Sección de Estados -->
              <!-- Sección de Estados y Recordatorio de Artículos del Cliente -->
              <hr>
              <div class="row align-items-start">
                <div class="col-lg-7 col-md-12 mb-3">
                  <h5>Estado del Trabajo</h5>
                  <ng-container *ngIf="selectedWorkStatus$ | async as statusDoc; else noStatusFound">
                    <p>
                      <strong>Estado Actual:</strong>
                      <span class="badge fs-6" [ngClass]="getStatusClass(statusDoc.currentStatus)">{{ getSpanishStatus(statusDoc.currentStatus) }}</span>
                      (Última act.: {{ statusDoc.lastUpdate?.toDate() | date:'short':'':'es-DO' }})
                    </p>
                    <p *ngIf="statusDoc.notes"><strong>Notas del estado actual:</strong> {{ statusDoc.notes }}</p>
                    <div *ngIf="statusDoc.history?.length" class="mt-3">
                      <h6>Historial de Estados:</h6>
                      <ul class="list-group list-group-flush status-history-list">
                        <li *ngFor="let entry of statusDoc.history" class="list-group-item list-group-item-light py-2">
                          <div class="d-flex w-100 justify-content-between">
                            <small class="fw-bold">{{ getSpanishStatus(entry.status) }}</small>
                            <small>{{ entry.timestamp?.toDate() | date:'dd/MM/yy HH:mm':'':'es-DO' }}</small>
                          </div>
                          <small *ngIf="entry.notes" class="d-block text-muted">Notas: {{ entry.notes }}</small>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-template #noStatusFound><div>No se encontró información de estado.</div></ng-template>
                </div>
                <div class="col-lg-5 col-md-12">
                  <!-- Formulario para cambiar estado -->
                  <form [formGroup]="statusChangeForm" (ngSubmit)="onSubmitStatusChange()" *ngIf="details.work.currentStatus !== 'Completed'" class="mb-3">
                    <div class="mb-2">
                      <select class="form-select form-select-sm" formControlName="newStatus">
                        <option value="" disabled>Cambiar estado a...</option>
                        <option *ngFor="let statOpt of availableStatusesForChange" [value]="statOpt.value">{{ statOpt.display }}</option>
                      </select>
                    </div>
                    <div class="mb-2">
                      <input type="text" class="form-control form-control-sm" placeholder="Notas opcionales" formControlName="statusNotes" />
                    </div>
                    <button type="submit" class="btn btn-sm btn-warning w-100" [disabled]="statusChangeForm.invalid || isUpdatingStatus">{{ isUpdatingStatus ? "Actualizando..." : "Actualizar Estado" }}</button>
                    <div *ngIf="statusUpdateError" class="alert alert-danger mt-2 py-1">{{ statusUpdateError }}</div>
                  </form>

                  <!-- Recordatorio de artículos dejados por el cliente -->
                  <div class="card border-warning-subtle shadow-sm bg-warning bg-opacity-10">
                    <div class="card-header bg-warning bg-opacity-25 py-2 d-flex justify-content-between align-items-center border-bottom border-warning-subtle">
                      <span class="fw-bold text-dark small">
                        <i class="bi bi-box-seam text-warning-emphasis me-1"></i> Artículos del Cliente (Devolver)
                      </span>
                      <span class="badge bg-warning text-dark border border-warning" *ngIf="details.work.clientItems?.length">
                        {{ details.work.clientItems!.length }}
                      </span>
                    </div>
                    <div class="card-body p-2">
                      <div *ngIf="details.work.clientItems && details.work.clientItems.length > 0; else noClientItemsDashboard">
                        <p class="small text-muted mb-2"><i class="bi bi-info-circle me-1"></i>Pertenencias a devolver al entregar la bicicleta:</p>
                        <ul class="list-group list-group-flush rounded border">
                          <li *ngFor="let item of details.work.clientItems" class="list-group-item list-group-item-light py-1 px-2 small d-flex align-items-center">
                            <i class="bi bi-arrow-return-right text-warning-emphasis me-2"></i>
                            <span class="fw-semibold">{{ item }}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-template #noClientItemsDashboard>
                        <p class="small text-muted mb-0 fst-italic py-1">
                          <i class="bi bi-dash-circle me-1"></i>Sin artículos adicionales registrados por el cliente.
                        </p>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #loadingWorkDetails>
          <div class="text-center p-5"><p class="mt-2">Cargando detalles del trabajo...</p></div>
        </ng-template>
      </div>
      <ng-template #noWorkSelected>
        <div class="alert alert-info" role="alert">
          Por favor seleccione un trabajo de la lista para ver los detalles, o cree uno nuevo.
        </div>
      </ng-template>
    </div>
  </div>

  <!-- MODAL DE CREAR NUEVO TRABAJO -->
  <div class="modal fade" #addWorkModal id="addWorkModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Crear nuevo trabajo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <form [formGroup]="newWorkshopWorkForm" (ngSubmit)="onCreateNewWork()">
          <div class="modal-body">
            <div *ngIf="createWorkError" class="alert alert-danger">{{ createWorkError }}</div>
            <fieldset class="mb-3">
              <legend class="h6">Paso 1: Cliente</legend>
              <div class="position-relative">
                  <div class="input-group">
                      <input type="text" class="form-control" placeholder="Buscar cliente..." [formControl]="clientSearchControl" [readOnly]="selectedClientForNewWork">
                      <button *ngIf="selectedClientForNewWork" class="btn btn-outline-secondary" type="button" (click)="clearClientSelectionForNewWork()"><i class="bi bi-x-lg"></i></button>
                  </div>
                  <div *ngIf="!selectedClientForNewWork && (filteredClients$ | async) as clients" class="list-group position-absolute w-100" style="z-index: 1056;">
                      <button *ngFor="let client of clients" type="button" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" (click)="selectClientForNewWork(client)">
                        <span>{{ client.name }}</span>
                        <small *ngIf="client.phone || client.email" class="text-muted ms-2">
                          {{ client.phone || client.email }}
                        </small>
                      </button>
                  </div>
              </div>
              <div class="form-text" style="font-weight: bold;">Si el cliente no existe, puede crearlo desde el módulo de clientes.</div>
              <button type="button" class="btn btn-sm btn-link ps-0" routerLink="/clients" (click)="bsModal.hide()">Ir a Gestionar Clientes</button>
            </fieldset>
            
            <fieldset class="mb-3" [disabled]="!selectedClientForNewWork">
              <legend class="h6">Paso 2: Bicicleta</legend>
              <div *ngIf="selectedClientForNewWork">
                  <select class="form-select" formControlName="selectedBike">
                      <option [ngValue]="null" disabled>Seleccione una bicicleta...</option>
                      <ng-container *ngIf="bikesForSelectedClient$ | async as bikes">
                          <option *ngFor="let bike of bikes" [ngValue]="bike">
                            {{ bike.brand }} {{ bike.model || '' }} - {{ bike.color }}{{ bike.isActive === false ? ' ⚠️ (Inactiva)' : '' }}
                          </option>
                          <option [ngValue]="null" disabled *ngIf="bikes.length === 0">Este cliente no tiene bicicletas.</option>
                      </ng-container>
                  </select>
                  <div *ngIf="newWorkshopWorkForm.get('selectedBike')?.value?.isActive === false" class="alert alert-warning py-1 px-2 mt-2 small mb-0 d-flex align-items-center">
                    <i class="bi bi-exclamation-triangle-fill me-2 fs-6"></i>
                    <span><strong>Atención:</strong> Esta bicicleta está marcada como <strong>inactiva</strong>.</span>
                  </div>
              </div>
            </fieldset>
            
            <fieldset [disabled]="!newWorkshopWorkForm.get('selectedBike')?.value">
              <legend class="h6">Paso 3: Detalles del Servicio</legend>
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="serviceType" class="form-label">Tipo de Servicio</label>
                  <select id="serviceType" class="form-select" formControlName="serviceType">
                      <option [ngValue]="null" disabled>Seleccione...</option>
                      <option value="Ride">Ride</option>
                      <option value="Full">Full</option>
                      <option value="Armado">Armado</option>
                      <option value="Ridewrap">Ridewrap</option>
                      <option value="Otros">Otros</option>
                  </select>
                </div>

                <div class="col-12 mb-3">
                  <label for="description" class="form-label">Solicitud del cliente</label>
                  <textarea class="form-control" id="description" rows="3" formControlName="description"></textarea>
                </div>

                <!-- Artículos traídos por el cliente (a devolver) -->
                <div class="col-12">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-box-seam me-1 text-primary"></i>Artículos / piezas que trajo el cliente <span class="text-muted fw-normal small">(opcional)</span>
                  </label>
                  <div class="input-group input-group-sm mb-2">
                    <input type="text" class="form-control" placeholder="Ej: Llave para batería, Neumáticos para cambio, Cargador..." 
                           [formControl]="clientItemInputControl" 
                           (keydown.enter)="$event.preventDefault(); addClientItem()">
                    <button type="button" class="btn btn-outline-primary" (click)="addClientItem()" [disabled]="!clientItemInputControl.value?.trim()">
                      <i class="bi bi-plus-lg me-1"></i>Agregar
                    </button>
                  </div>
                  <small class="form-text text-muted d-block mb-2">
                    Registre los artículos o partes que el cliente dejó para mantener visibilidad y devolverle al finalizar el trabajo.
                  </small>
                  <div *ngIf="clientItems.length > 0" class="d-flex flex-wrap gap-2 pt-1">
                    <span *ngFor="let item of clientItems; let i = index" class="badge bg-warning text-dark border border-warning-subtle d-inline-flex align-items-center py-2 px-2 shadow-xs">
                      <i class="bi bi-tag-fill me-1 text-secondary"></i>
                      <span>{{ item }}</span>
                      <button type="button" class="btn-close ms-2" style="font-size: 0.65rem;" (click)="removeClientItem(i)" aria-label="Eliminar"></button>
                    </span>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary" [disabled]="newWorkshopWorkForm.invalid || isCreatingWork">{{ isCreatingWork ? 'Creando...' : 'Crear Trabajo' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <!-- MODAL DE ÍTEM PERSONALIZADO -->
  <div class="modal fade" #customItemModal id="customItemModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Agregar {{ customItemType === 'Labor' ? 'Servicio' : 'Artículo' }} Personalizado</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <form [formGroup]="customItemForm" (ngSubmit)="onAddCustomItem()">
            <div class="modal-body">
              <div class="mb-3">
                <label for="productName" class="form-label">Nombre del artículo/servicio</label>
                <input type="text" class="form-control" id="productName" formControlName="productName">
              </div>
              <div class="row">
                <div class="col-6 mb-3">
                  <label for="unitPrice" class="form-label">Precio unitario</label>
                  <input type="number" class="form-control" id="unitPrice" formControlName="unitPrice">
                </div>
                <div class="col-6 mb-3">
                  <label for="quantity" class="form-label">Cantidad</label>
                  <input type="number" class="form-control" id="quantity" formControlName="quantity">
                </div>
              </div>
              <!-- ASIGNACIÓN PERSONALIZADOS -->
              <div class="mb-3">
                <label class="form-label">Personal Asignado</label>
                <select class="form-select" formControlName="assignee1">
                  <option [ngValue]="null">Personal (N/A)</option>
                  <option *ngFor="let emp of allActiveEmployees$ | async" [value]="emp.id">{{ emp.type === 'Mecánico' ? 'Mec' : 'Asis' }}: {{ emp.name }}</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" class="btn btn-primary" [disabled]="customItemForm.invalid">Agregar</button>
            </div>
          </form>
        </div>
      </div>
  </div>
</div>